export class SelfAssessmentColumnModel {
  id: boolean;
  type: boolean;
  ruleId: boolean;
  assessmentTeam: boolean;
  assessor: boolean;
  assessorDelegate: boolean;
  assessmentDueDate: boolean;
  assessmentStatus: boolean;
  assessmentCreationDate: boolean;
  reviewTeam: boolean;
  reviewer: boolean;
  reviewerDelegate: boolean;
  reviewDueDate: boolean;
  reviewStatus: boolean;
  overallStatus: boolean;
  conclusion: boolean;
  owner: boolean;
  assessmentLastEdited: boolean;

  constructor() {
    this.id = true;
    this.type = true;
    this.ruleId = true;
    this.assessmentTeam = true;
    this.assessor = true;
    this.assessorDelegate = true;
    this.assessmentDueDate = true;
    this.assessmentStatus = true;
    this.assessmentCreationDate = true;
    this.reviewTeam = true;
    this.reviewer = true;
    this.reviewDueDate = true;
    this.reviewStatus = true;
    this.reviewerDelegate = true;
    this.overallStatus = true;
    this.conclusion = true;
    this.owner = true;
    this.assessmentLastEdited = true;
  }
}


export class SelfAssessmentT2ColumnModel {
  id: boolean;
  part: boolean;
  owner: boolean;
  assessmentCategory: boolean;
  assessmentDueDate: boolean;
  assessmentTeam: boolean;
  assessor: boolean;
  assessmentStatus: boolean;
  assessmentCreationDate: boolean;
  complianceStatus: boolean;
  interpretation: boolean;
  judgement: boolean;
  noOfJudgements: boolean;
  gaps: boolean;
  noOfGaps: boolean;
  noOfGapsRiskAccepted: boolean;
  enhancement: boolean;
  noOfEnhancement: boolean;
  riskRecommendation: boolean;
  riskRecommendationStatus: boolean;
  reviewerTeam: boolean;
  reviewer: boolean;
  reviewStatus: boolean;
  approvalTeam: boolean;
  approvers: boolean;
  approvalStatus: boolean;
  lastApproved: boolean;

  constructor() {
    this.id = true;
    this.noOfJudgements = true;
    this.noOfGaps = true;
    this.noOfGapsRiskAccepted = true;
    this.noOfEnhancement = true;
    this.part = true;
    this.assessmentCategory = true;
    this.complianceStatus = true;
    this.lastApproved = true;
    this.assessmentCreationDate = true;
    this.interpretation = true;
    this.assessmentTeam = true;
    this.assessor = true;
    this.judgement = true;
    this.gaps = true;
    this.reviewer = true;
    this.enhancement = true;
    this.assessmentStatus = true;
    this.assessmentDueDate = true;
    this.reviewStatus = true;
    this.riskRecommendation = true;
    this.riskRecommendationStatus = true;
    this.owner = true;
    this.reviewerTeam = true;
    this.approvalTeam = true;
    this.approvers = true;
    this.approvalStatus = true;
  }
}
export class SelfAssessmentT3ColumnModel {
  id: boolean;
  Rulebook: boolean;
  part: boolean;
  ruleId: boolean;
  ruleOwner: boolean;
  complianceStatus: boolean;
  assessmentStatus: boolean;
  reviewDate: boolean;
  assessmentDate: boolean;
  lbgImpact: boolean;
  rfbImpact: boolean;
  lbcmImpact: boolean;
  nextAssessmentDueDate: boolean;
  action: boolean;

  constructor() {
    this.id = true;
    this.Rulebook = true;
    this.part = true;
    this.ruleId = true;
    this.ruleOwner = true;
    this.complianceStatus = true;
    this.assessmentStatus = true;
    this.reviewDate = true;
    this.assessmentDate = true;
    this.lbgImpact = true;
    this.rfbImpact = true;
    this.lbcmImpact = true;
    this.nextAssessmentDueDate = true;
    this.action = true;
  }
}

